import { render, staticRenderFns } from "./arrowFront.vue?vue&type=template&id=03d6ef5c&"
import script from "./arrowFront.vue?vue&type=script&lang=js&"
export * from "./arrowFront.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports